var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "tw-flex tw-flex-col tw-pl-6 tw-pt-20 league-table-container tw-h-full",
      attrs: { "data-v-4ac0018f": "", "data-v-1d97b569": "" }
    },
    [
      _c(
        "v-row",
        [
          _c("v-col", { attrs: { cols: "1" } }, [
            _c(
              "label",
              {
                staticClass:
                  "tw-mr-4 tw-font-semibold tw-text-2xl tw-text-gray-700"
              },
              [_vm._v("Title: ")]
            )
          ]),
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("v-text-field", {
                staticClass: "tw-mt-1",
                attrs: { outlined: "", "background-color": "white", dense: "" },
                model: {
                  value: _vm.editManOfTheMatch.name,
                  callback: function($$v) {
                    _vm.$set(_vm.editManOfTheMatch, "name", $$v)
                  },
                  expression: "editManOfTheMatch.name"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "1" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", width: "100%" },
                  on: { click: _vm.saveDisplayName }
                },
                [_vm._v("Save")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "row", attrs: { "data-v-9f7913b4": "" } }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "col-3 text-right" },
          [
            _c("PickParentLeaguesModal", {
              attrs: {
                step: 1,
                manOfTheMatch: _vm.editManOfTheMatch,
                selectedLeagues: _vm.GetIds(_vm.filteredManOfTheMatch)
              },
              on: {
                leagueAdded: function($event) {
                  return _vm.$emit("getInitialData")
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "v-row",
        { staticClass: "tw-flex-grow-0 leagues-table-container" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              !_vm.filteredManOfTheMatch.length
                ? _c("span", { staticClass: "text-lg tw-text-gray-800" }, [
                    _vm._v("There are no leagues to show")
                  ])
                : _vm._e(),
              _vm._l(_vm.filteredManOfTheMatch, function(league, index) {
                return _c(
                  "div",
                  {
                    key: "league-" + index,
                    staticClass:
                      "tw-w-full tw-p-4 tw-flex tw-flex-row tw-flex-wrap tw-flex-grow-0 tw-justify-start tw-items-center tw-bg-white tw-cursor-pointer hover:tw-bg-blue-100 tw-mb-1 venue-table-row tw-border-2 tw-border-transparent",
                    on: {
                      click: function($event) {
                        return _vm.handleClick(league.league)
                      }
                    }
                  },
                  [
                    league.leagueByLeague.league_type === "full"
                      ? _c("v-icon", { staticClass: "tw-mr-3" }, [
                          _vm._v("mdi-format-list-numbered")
                        ])
                      : _c("v-icon", { staticClass: "tw-mr-3" }, [
                          _vm._v("mdi-view-column-outline")
                        ]),
                    _c(
                      "span",
                      {
                        staticClass: "tw-mr-6 tw-capitalize",
                        staticStyle: { width: "360px" }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("shortenString")(
                              league.leagueByLeague.display_name
                            )
                          )
                        )
                      ]
                    ),
                    league.leagueByLeague.league_type === "full"
                      ? _c(
                          "span",
                          {
                            staticClass: "tw-mr-6 tw-capitalize",
                            staticStyle: { width: "300px" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                league.leagueByLeague.season || "No Season"
                              ) +
                                " | " +
                                _vm._s(
                                  _vm._f("dateToYear")(
                                    league.leagueByLeague.kick_off_date
                                  )
                                ) +
                                " | "
                            ),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  league.leagueByLeague.locationObj.city.name
                                )
                              )
                            ])
                          ]
                        )
                      : _c(
                          "span",
                          {
                            staticClass: "tw-mr-6 tw-capitalize",
                            staticStyle: { width: "300px" }
                          },
                          [
                            _vm._v(
                              "Mini-League | " +
                                _vm._s(
                                  _vm._f("dateToYear")(
                                    league.leagueByLeague.kick_off_date
                                  )
                                ) +
                                " | "
                            ),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  league.leagueByLeague.locationObj.city.name
                                )
                              )
                            ])
                          ]
                        ),
                    _c(
                      "span",
                      {
                        staticClass: "tw-mr-6 tw-capitalize",
                        staticStyle: { width: "160px" }
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(league.leagueByLeague.locationObj.name))
                        ])
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "tw-mr-6 tw-capitalize",
                        staticStyle: { width: "200px" }
                      },
                      [
                        _vm._v(
                          _vm._s(league.leagueByLeague.player_type) +
                            " " +
                            _vm._s(league.leagueByLeague.team_size) +
                            " "
                        )
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "tw-mr-6",
                        staticStyle: { width: "110px" }
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm._f("day")(league.leagueByLeague.day_of_week)
                            )
                          )
                        ])
                      ]
                    ),
                    league.leagueByLeague.league_type === "mini-league"
                      ? _c(
                          "span",
                          {
                            staticClass: "tw-mr-6",
                            staticStyle: { width: "80px" }
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  league.leagueByLeague.placeholdersInLeague
                                    .length
                                ) + " Teams"
                              )
                            ])
                          ]
                        )
                      : _c(
                          "span",
                          {
                            staticClass: "tw-mr-6",
                            staticStyle: { width: "80px" }
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  league.leagueByLeague.league_teams.length
                                ) + " Teams"
                              )
                            ])
                          ]
                        ),
                    _c(
                      "div",
                      { staticClass: "tw-flex tw-flex-grow-0" },
                      [
                        league.leagueByLeague.status === "planned"
                          ? _c(
                              "v-icon",
                              {
                                staticClass: "tw-mr-2",
                                attrs: { color: "primary" }
                              },
                              [_vm._v("mdi-circle")]
                            )
                          : league.leagueByLeague.status === "active"
                          ? _c(
                              "v-icon",
                              {
                                staticClass: "tw-mr-2",
                                attrs: { color: "success" }
                              },
                              [_vm._v("mdi-circle")]
                            )
                          : _c(
                              "v-icon",
                              {
                                staticClass: "tw-mr-2",
                                attrs: { color: "secondary" }
                              },
                              [_vm._v("mdi-circle")]
                            ),
                        _c("span", { staticClass: "tw-capitalize" }, [
                          _vm._v(_vm._s(league.leagueByLeague.status))
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col col-9", attrs: { "data-v-9f7913b4": "" } },
      [
        _c(
          "h1",
          {
            staticClass: "tw-font-semibold tw-text-2xl mt-4",
            attrs: { "data-v-9f7913b4": "" }
          },
          [_vm._v("Parent Leagues:")]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }